// --------------------------------------------------------------
// Created On: 2024-05-20
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";

// A button for adding attributes to a card.
export default function AddAttributeButton(props: Props): Component {
  return (
    <button
      data-test="add-card-attribute-button"
      type="submit"
      className="btn btn-success float-end"
      onClick={() => props.onAddAttribute()}
      disabled={props.disabled || props.currentAttributeCount >= props.maxAttributes}
    >
      <span className="d-none d-sm-inline">Add Attribute</span>
      <i className="d-inline d-sm-none fa fa-fw fa-plus fa-xs" />
    </button>
  );
}

interface Props {
  currentAttributeCount: number;
  maxAttributes: number;
  onAddAttribute: () => void;
  disabled?: boolean;
}
